import React, { ChangeEvent, useMemo } from "react";
import { observer } from "mobx-react-lite";
import { Checkbox } from "@mui/material";

import "./Checkbox.scss";
import useTheme from "../../services/theme-service/ThemeService";
import { translationService } from "../../services/translation/TranslationService";

interface ICheckbox {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  labelKey?: string;
  checked?: boolean;
  readOnly?: boolean;
  className?: string;
}

export default observer((props: ICheckbox) => {
  const { themeClass } = useTheme();

  const className = useMemo(() => {
    if (props.className) return `${themeClass(["checkbox-container"])} ${props.className}`;

    return themeClass(["checkbox-container"]);
  }, [themeClass, props.className]);

  return (
    <label className={className}>
      <Checkbox
        className="checkbox"
        readOnly={props.readOnly}
        checked={props.checked}
        onChange={props.onChange}
      />
      {props.labelKey && (
        <span className="checkbox-label">{translationService.translate(props.labelKey)}</span>
      )}
    </label>
  );
});
